import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconForumChatBubble = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.88998 13.03C8.45884 13.03 8.91998 12.5689 8.91998 12C8.91998 11.4311 8.45884 10.97 7.88998 10.97C7.32113 10.97 6.85999 11.4311 6.85999 12C6.85999 12.5689 7.32113 13.03 7.88998 13.03Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.03 12C13.03 12.5689 12.5688 13.03 12 13.03C11.4311 13.03 10.97 12.5689 10.97 12C10.97 11.4311 11.4311 10.97 12 10.97C12.5688 10.97 13.03 11.4311 13.03 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.14 12C17.14 12.5689 16.6789 13.03 16.11 13.03C15.5412 13.03 15.08 12.5689 15.08 12C15.08 11.4311 15.5412 10.97 16.11 10.97C16.6789 10.97 17.14 11.4311 17.14 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 2C6.47579 2 2 6.47579 2 12C2 17.5242 6.47579 22 12 22C13.5469 22 15.0151 21.641 16.3216 21.0162L21.0902 21.7219C21.3249 21.7567 21.5621 21.6783 21.73 21.5107C21.8978 21.343 21.9765 21.1058 21.9421 20.8711L21.2106 15.8853C21.7121 14.6922 22 13.376 22 12C22 6.47579 17.5242 2 12 2ZM19.7456 15.4932C19.6692 15.6637 19.6601 15.854 19.7154 16.0277L20.3114 20.0903L16.3098 19.4981C16.156 19.4753 15.999 19.5009 15.8603 19.5713C14.7006 20.1604 13.3865 20.5 12 20.5C7.30421 20.5 3.5 16.6958 3.5 12C3.5 7.30421 7.30421 3.5 12 3.5C16.6958 3.5 20.5 7.30421 20.5 12C20.5 13.2383 20.2248 14.4241 19.7456 15.4932Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconForumChatBubble as ReactComponent };
